export default "__VITE_ASSET__9c87297c__"